import React from 'react';
import { BagProtectionContract, BagProtectionDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const BagProtectionNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_BagProtectionDetails"
      component={BagProtectionDetails}
    />
    <Stack.Screen
      name="MarisaServicos_BagProtectionContract"
      component={BagProtectionContract}
    />
  </Stack.Group>
);
